import React, { Component, useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import SettingsSidebar from "../Sidebar/settingsidebar";
import swal from 'sweetalert';
import Header from "../Sidebar/header";
import Approval from "../../assets/img/profiles/approval.svg";
import Edit from "../../assets/img/profiles/edit.svg";
import Select from "react-select";
import { FaMinus, FaPlus } from "react-icons/fa";
import axios from "axios";

const ApprovalPermission = () => {
  const [menu, setMenu] = useState(false);
  const [displayPage, setDisplayPage] = useState("leave");
  const [getallGrp, setGetallGrp] = useState([]);
  const [groupname, setGroupname] = useState("");
  const [modulename, setModuleName] = useState(null);
  const [level1, setLevel1] = useState(null);
  const [level2, setLevel2] = useState(null);
  const [level3, setLevel3] = useState(null);

  const [getEmpl, setGetEmpl] = useState([]);
  const [member, setMemebr] = useState(null);
  const [groupset, setGroupset] = useState(null);
  const [moduleset, setmoduleset] = useState(null);
  const [getgrpname, setgetgrpname] = useState([]);
  const [showmem, setShowmem] = useState([]);
  // new requirements
  const [deleteGroupName, setDeleteGroupName] = useState("");
  const [editingGroup, setEditingGroup] = useState(null);
  // For tracking new members to be added to group
  const [newMembersToAdd, setNewMembersToAdd] = useState(null);

  // For tracking existing members selected for removal
  const [selectedMembersForRemoval, setSelectedMembersForRemoval] = useState([]);

  // Current members in the group being edited
  const [currentGroupMembers, setCurrentGroupMembers] = useState([]);
  const modalCloseRef = useRef(null);
  const modalCloseRef2 = useRef(null);

  ////////
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const token = sessionStorage.getItem("access_token");

  /**************Function to get All Group Info************* */
  const GetGroup = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/approval_matrixs/`,
        {
          params: {
            coregid: sessionStorage.getItem("coid"),
            // coregid:"Sapi141335",
            module_type: displayPage,
          },
        }
      );
      const data = await res.data;

      console.log(data, "all grp data");
      setGetallGrp(res.data);

      // setGetEmpl(res.data.map((ele)=>({label:ele.name, value:ele.empid})))
    } catch (err) {
      console.log(err);
    }
  };

  const GetGroupName = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/approval_members/`,
        {
          params: {
            coregid: sessionStorage.getItem("coid"),
            // coregid:"Sapi141335",
            module_type: displayPage,
          },
        }
      );
      const data = await res.data;

      console.log(data);
      // setGetallGrp(res.data)
      setgetgrpname(res.data);

      // setGetEmpl(res.data)
    } catch (err) {
      console.log(err);
    }
  };

  const GetEmp = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/master_employees/`,
        {
          params: {
            coregid: sessionStorage.getItem("coid"),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.data;

      console.log(data);

      setGetEmpl(
        res.data.map((ele) => ({ label: ele.name, value: ele.empid }))
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddMember = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/approval_members/`,
        {
          coregid: sessionStorage.getItem("coid"),
          module_type: displayPage,
          group_name: groupset.value,
          members: member.map((ele) => ele.value),
        }
      );
  
      // Check the response data for error status
      if (res.data.status === "error") {
        const conflictNames = res.data.conflicts?.map(c => c.group_name).join(", ") || "";
        throw {
          response: {
            data: {
              message: res.data.message,
              conflicts: res.data.conflicts
            }
          }
        };
      }
  
      // Only show success if status is not "error"
      swal("Success", "Members added successfully", "success");
      modalCloseRef2.current?.click();
      GetGroup();
    } catch (err) {
      console.log(err);
      if (err.response && err.response.data) {
        const errorData = err.response.data;
        const conflictNames = errorData.conflicts?.map(c => c.group_name).join(", ") || "";
        
        swal("Error", 
          `${errorData.message || 'An error occurred'}${conflictNames ? `. Conflicts in groups: ${conflictNames}` : ''}`,
          "error"
        );
        modalCloseRef2.current?.click();
      } else {
        swal("Error", "An unexpected error occurred", "error");
        modalCloseRef2.current?.click();
      }
    }
  };

  useEffect(() => {
    GetEmp();
  }, []);

  // const PostGroup = async () => {
  //   try {
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/approval_matrixs/`,
  //       // {
  //       //   params: {
  //       //     coregid:sessionStorage.getItem("coid"),
  //       //     coregid:"Sapi141335",
  //       //     module_type:"leave"
  //       //   },

  //       // }
  //       {
  //         group_name: groupname,
  //         module_type: modulename.value,
  //         coregid: sessionStorage.getItem("coid"),
  //         // "coregid": "Sapi141335",
  //         approval_level: [
  //           {
  //             level: 1,
  //             ids: level1.map((ele) => ele.value),
  //           },
  //           {
  //             level: 2,
  //             ids: level2.map((ele) => ele.value),
  //           },
  //           {
  //             level: 3,
  //             ids: level3.map((ele) => ele.value),
  //           },
  //         ].filter((item) => item.ids.length !== 0),
  //       }
  //     );
  //     const data = await res.data;

  //     // console.log(data)
  //     alert("added Successfully");
  //     GetGroup();

  //     // setGetEmpl(res.data.map((ele)=>({label:ele.name, value:ele.empid})))
  //   } catch (err) {
  //     console.log("error in adding grp",err);
  //   }
  // };
  /******************************************************** */
  /********************** */

  const PostGroup = async () => {
    try {
      const approvalLevels = [
        {
          level: 1,
          ids: level1?.map((ele) => ele.value) || [],
        },
        {
          level: 2,
          ids: level2?.map((ele) => ele.value) || [],
        },
        {
          level: 3,
          ids: level3?.map((ele) => ele.value) || [],
        }
      ].filter((item) => item.ids.length > 0);

      if (approvalLevels.length === 0) {
        swal("Warning", "Please select at least one approver level", "warning");
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/approval_matrixs/`,
        {
          group_name: groupname,
          module_type: modulename.value,
          coregid: sessionStorage.getItem("coid"),
          approval_level: approvalLevels
        }
      );

      await res.data;
      swal("Success", "Added Successfully", "success");
      modalCloseRef.current?.click();
      GetGroup();
    } catch (err) {
      console.log("error in adding grp", err);
      swal("Error", "Some error occurred while adding approval group", "error");
    }
  };

  const UpdateGroup = async () => {
    try {
      const approvalLevels = [
        {
          level: 1,
          ids: level1?.map((ele) => ele.value) || [],
        },
        {
          level: 2,
          ids: level2?.map((ele) => ele.value) || [],
        },
        {
          level: 3,
          ids: level3?.map((ele) => ele.value) || [],
        }
      ].filter((item) => item.ids.length > 0);

      if (approvalLevels.length === 0) {
        swal("Warning", "Please select at least one approver level", "warning");
        return;
      }

      const res = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/approval_matrixs/`,
        {
          group_name: groupname,
          module_type: modulename.value,
          coregid: sessionStorage.getItem("coid"),
          approval_level: approvalLevels
        }
      );

      await res.data;
      swal("Success", "Updated Successfully", "success");
      modalCloseRef.current?.click();
      GetGroup();

      // Close the modal and reset form
      // document.querySelector('.close-btn').click();
      // setEditingGroup(null);
      // setGroupname("");
      // setModuleName(null);
      // setLevel1(null);
      // setLevel2(null);
      // setLevel3(null);
    } catch (err) {
      console.log("error in updating grp", err);
      swal("Error", "Error occurred while updating approval group", "error");
    }
  };

  const deleteGroup = async (groupName) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/approval_matrixs/`,
        {
          data: {
            grp_name: groupName,
            coregid: sessionStorage.getItem("coid")
          }
        }
      );

      if (response.status === 200) {
        // alert("Group deleted successfully");
        swal("Success", "Deleted Successfully", "success");

        GetGroup(); // Refresh the group list
      }
    } catch (error) {
      console.error("Error deleting group:", error);
      // alert("Failed to delete group");
      swal("Error", "Some issue occured while deleting the group please try again in sometime", "error");

    }
  };

  // Function to add members
  const handleAddMembers = async () => {
    if (!newMembersToAdd || newMembersToAdd.length === 0) {
      swal("Warning", "Please select at least one member to add", "warning");
      return;
    }

    let loadingSwal;
    try {
      loadingSwal = swal({
        title: "Processing...",
        text: "Adding members to the group",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        timer: 30000
      });

      const newMemberIds = newMembersToAdd.map(m => m.value);

      const res = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/approval_members/`,
        {
          coregid: sessionStorage.getItem("coid"),
          module_type: displayPage,
          group_name: editingGroup.group_name,
          members: newMemberIds
        }
      );

      // Only update UI after successful backend response
      if (res.data.status === "success") {
        setCurrentGroupMembers(prevMembers => [
          ...prevMembers,
          ...newMembersToAdd.map(member => ({
            id: member.value,
            name: member.label.replace(/\(.*\)/, '').trim()
          }))
        ]);

        swal("Success", "Members Added Successfully", "success");
        GetGroup();
        GetGroupName();
        setNewMembersToAdd(null);
      } else {
        // Handle backend validation errors
        const conflictNames = res.data.conflicts?.map(c => c.group_name).join(", ") || "";
        swal("Error",
          `${res.data.message}. Conflicts in groups: ${conflictNames}`,
          "error"
        );
      }

    } catch (err) {
      console.error("Error adding members:", err.response?.data || err);
      swal("Error",
        err.response?.data?.message ||
        "Some error occurred while adding members. Please try again",
        "error"
      );
    } finally {
      if (loadingSwal?.close && !loadingSwal.isClosed) {
        loadingSwal.close();
      }
    }
  };

  // Function to remove members
  const handleRemoveMembers = async () => {
    if (selectedMembersForRemoval.length === 0) {
      swal("Warning", "Please select at least one member to remove", "warning");
      return;
    }

    // Show loading indicator with safety timer
    let loadingSwal;
    try {
      loadingSwal = swal({
        title: "Processing...",
        text: "Removing members from the group",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        timer: 30000 // 30s fallback auto-close
      });

      const res = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/approval_members/`,
        {
          data: {
            coregid: sessionStorage.getItem("coid"),
            module_type: displayPage,
            group_name: editingGroup.group_name,
            members: selectedMembersForRemoval
          }
        }
      );

      // Optimistic UI update
      setCurrentGroupMembers(prevMembers =>
        prevMembers.filter(member => !selectedMembersForRemoval.includes(member.id))
      );

      // Explicit close before showing success
      if (loadingSwal.close) {
        loadingSwal.close();
      }

      swal("Success", "Members removed successfully", "success");
      GetGroup();
      GetGroupName();
      setSelectedMembersForRemoval([]);

    } catch (err) {
      console.error("Error removing members:", err.response?.data || err);
      if (loadingSwal?.close) {
        loadingSwal.close();
      }
      swal("Error",
        err.response?.data?.message ||
        "Failed to remove members. Please try again later",
        "error"
      );
    } finally {
      // Ultimate safeguard
      if (loadingSwal?.close && !loadingSwal.isClosed) {
        loadingSwal.close();
      }
    }
  };
  /*********************** */
  useEffect(() => {
    GetGroup();
    GetGroupName();
  }, [displayPage]);

  const handleAddNewGroup = () => {
    setEditingGroup(null);
    setGroupname("");
    setModuleName(null);
    setLevel1(null);
    setLevel2(null);
    setLevel3(null);
  };

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <SettingsSidebar />
      <div className="page-wrapper">
        {/* Page Content */}
        {/* <button onClick={()=>PostGroup()}>add</button> */}
        <div className="content container-fluid">
          {/* /Page Header */}
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {/* <div className="page-header">
                    <h4>
                      <img src={Approval} /> <span>Approval</span>
                    </h4>
                  </div> */}
                  <div className="row align-items-center">
                    <div className="col">
                      <h4>
                        <img src={Approval} /> <span>Approval</span>
                      </h4>
                    </div>
                    <div className="col-auto float-end">
                      <div className="view-icons">
                        <button
                          className="btn btn-success btn-block "
                          style={{
                            padding: "5px 20px",
                            fontSize: "15px",
                            background: "#477BFF",
                            border: "none",
                            color: "white",
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#add_group"
                          href="#"
                          onClick={() => GetGroupName()}
                        >
                          + Add Members
                        </button>
                      </div>
                      &nbsp;
                      <div className="view-icons">
                        <button
                          className="btn btn-success btn-block "
                          style={{
                            padding: "5px 20px",
                            fontSize: "15px",
                            background: "#477BFF",
                            border: "none",
                            color: "white",
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#edit_group"
                          onClick={handleAddNewGroup}
                          href="#"
                        // onClick={() =>}
                        >
                          + Add Group
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="col-auto float-start ml-auto mt-4">
                        <div>
                          <button
                            className="btn btn-success btn-block "
                            style={{
                              padding: "6px 15px",
                              fontSize: "15px",
                              borderRadius: "8px 0px 0px 8px",
                              background:
                                displayPage === "leave" ? "#477BFF" : "#FFFFFF",
                              border: "none",
                              color:
                                displayPage === "leave" ? "#FFFFFF" : "#344767",
                            }}
                            // data-bs-toggle="modal"
                            // data-bs-target="#personal_info_modal"
                            onClick={() => {
                              setDisplayPage("leave");
                            }}
                          >
                            {" "}
                            Leave
                          </button>

                          <button
                            className="btn btn-success btn-block "
                            style={{
                              padding: "6px 15px",
                              fontSize: "15px",
                              borderRadius: "0px",
                              background:
                                displayPage === "attendance"
                                  ? "#477BFF"
                                  : "#FFFFFF",
                              border: "none",
                              color:
                                displayPage === "attendance"
                                  ? "#FFFFFF"
                                  : "#344767",
                            }}
                            // data-bs-toggle="modal"
                            // data-bs-target="#personal_info_modal"
                            onClick={() => {
                              setDisplayPage("attendance");
                            }}
                          >
                            Attendance
                          </button>

                          <button
                            className="btn btn-success btn-block "
                            style={{
                              padding: "6px 15px",
                              fontSize: "15px",
                              borderRadius: "0px 8px 8px 0px",
                              background:
                                displayPage === "reimbursement"
                                  ? "#477BFF"
                                  : "#FFFFFF",
                              border: "none",
                              color:
                                displayPage === "reimbursement"
                                  ? "#FFFFFF"
                                  : "#344767",
                            }}
                            onClick={() => {
                              setDisplayPage("reimbursement");
                            }}
                          >
                            Reimbursement
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-4">
                    <div className="row col-md-12">
                      {getallGrp.map((ele) => (
                        <div className="col-lg-4 col-sm-6 col-md-4 col-xl-4">
                          <div
                            className="card"
                            style={{
                              height: "380px",
                              borderRadius: "16px",
                              border: "1px solid #D9D9D9",
                            }}
                          >
                            <div className="card-body">
                              {/* <div style={{display:"flex", justifyContent:"space-between", flexDirection:"row"}}>

                            </div> */}
                              <div style={{ float: "right" }}>
                                <button
                                  style={{ background: "none", border: "none" }}
                                  title="Edit Group"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_group"
                                  onClick={() => {
                                    setEditingGroup(ele);
                                    setGroupname(ele.group_name);
                                    setModuleName({ label: ele.module_type, value: ele.module_type });

                                    // Extract approver IDs from all possible levels
                                    const level1Approvers = ele.approval_level?.Level_1?.map(user => user.id) || [];
                                    const level2Approvers = ele.approval_level?.Level_2?.map(user => user.id) || [];
                                    const level3Approvers = ele.approval_level?.Level_3?.map(user => user.id) || [];

                                    // Handle missing approvers
                                    const allApproverIds = [...level1Approvers, ...level2Approvers, ...level3Approvers];
                                    const missingApprovers = allApproverIds.filter(id => !getEmpl.some(emp => emp.value === id));

                                    const allOptions = [
                                      ...getEmpl,
                                      ...missingApprovers.map(id => ({ value: id, label: `Unknown (${id})` }))
                                    ];

                                    // Determine how many levels we have
                                    const hasLevel3 = level3Approvers.length > 0;
                                    const hasLevel2 = level2Approvers.length > 0;

                                    // Set levels with conditional logic
                                    if (hasLevel3) {
                                      // 3-level case: Reverse order (3→1, 2→2, 1→3)
                                      setLevel1(level3Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                      setLevel2(level2Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                      setLevel3(level1Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                    }
                                    else if (hasLevel2) {
                                      // 2-level case: Reverse order (2→1, 1→2)
                                      setLevel1(level2Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                      setLevel2(level1Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                      setLevel3([]);
                                    }
                                    else {
                                      // 1-level case: Show in level1 (or reverse if needed)
                                      setLevel1(level1Approvers.map(id => allOptions.find(emp => emp.value === id)).filter(Boolean));
                                      setLevel2([]);
                                      setLevel3([]);
                                    }
                                  }}
                                >
                                  <img src={Edit} height={"17px"} />
                                </button>
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                  }}
                                  title="Delete Group"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deleteConfirmModal"
                                  onClick={() => setDeleteGroupName(ele.group_name)}
                                >
                                  <i className="fa fa-trash text-danger" aria-hidden="true"></i>
                                </button>

                              </div>
                              <p
                                style={{
                                  color: "#666666",
                                  fontWeight: "400",
                                  fontSize: "16px",
                                  lineHeight: "25px",
                                }}
                              >
                                Group Name :{" "}
                                <span style={{ color: "#0C41FF" }}>
                                  {ele.group_name}
                                </span>
                              </p>
                              <p
                                style={{
                                  color: "#666666",
                                  fontWeight: "400",
                                  fontSize: "16px",
                                  lineHeight: "25px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  margin: "0" // Remove default paragraph margins
                                }}
                              >
                                <span>
                                  Number Of Members In Group:{" "}
                                  <span
                                    style={{ color: "#0C41FF", cursor: "pointer" }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#show_mem"
                                    onClick={() => setShowmem(ele.members)}
                                  >
                                    {ele.members.length}
                                  </span>
                                </span>
                                {/* {ele.members && ele.members.length > 0 && */}
                                <button
                                  className="btn btn-sm"
                                  data-bs-toggle="modal"
                                  data-bs-target="#editMembersModal"
                                  onClick={() => {
                                    setEditingGroup(ele);
                                    setCurrentGroupMembers(ele.members || []);
                                    setSelectedMembersForRemoval([]);
                                    setNewMembersToAdd(null);
                                  }}
                                  title="Edit Member List"
                                  style={{
                                    padding: "0.05rem 0.05rem", // Smaller padding for compact look
                                    marginLeft: "8px" // Small gap from the text
                                  }}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                                {/* }*/}
                              </p>
                              <hr />
                              <p
                                style={{
                                  color: "#666666",
                                  fontWeight: "400",
                                  fontSize: "16px",
                                  lineHeight: "25px",
                                }}
                              >
                                Number Of Approval Levels :{" "}
                                <span style={{ color: "#0C41FF" }}>
                                  {Object.keys(ele.approval_level).length}
                                </span>
                              </p>
                              <hr />
                              <p
                                style={{
                                  color: "#666666",
                                  fontWeight: "400",
                                  fontSize: "16px",
                                  lineHeight: "25px",
                                }}
                              >
                                Approval Leave Authority :
                              </p>
                              {Object.entries(ele.approval_level)
                                .reverse()
                                .map((item, i) => (
                                  <p
                                    style={{
                                      color: "#666666",
                                      fontWeight: "400",
                                      fontSize: "16px",
                                      lineHeight: "25px",
                                    }}
                                  >
                                    {console.log(item)}
                                    {`Level ${i + 1}`} :{" "}
                                    <span style={{ color: "#0C41FF" }}>
                                      {item[1].map((el) => el.name).toString()}
                                    </span>
                                    {console.log(item)}
                                  </p>
                                ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
        <div
          id="add_group"
          className="modal custom-modal fade"
          role="dialog"
        //data-bs-backdrop="static"
        //data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: "615px" }}>
              {/* <div className="modal-header">
                <br />
                <br />
                <br />
                <h5 className="modal-title">
                  <b>Add Group</b>
                </h5>
                 </div> */}

              {/* <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close"

              >
                X
              </button> */}
              <button
                ref={modalCloseRef2}
                type="button"
                className="btn-close mt-2 me-2 ms-auto"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="modal-body">
                <p
                  style={{
                    color: "#000000",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "25px",
                  }}
                >
                  Group Name :{" "}
                  <span style={{ color: "#0C41FF" }}>
                    <Select
                      options={getgrpname}
                      value={groupset}
                      onChange={(e) => setGroupset(e)}
                    />
                  </span>
                </p>
                <hr />
                <p
                  style={{
                    color: "#000000",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "25px",
                  }}
                >
                  Add Member
                </p>
                <div className="row col-sm-12">
                  <div className="col-sm-10">
                    <div style={{ width: "100%" }}>
                      <Select
                        isMulti
                        // options={managerList?.filter(
                        //   (item) =>
                        //     !roleList
                        //       ?.filter((ele) => roleID == ele.id)[0]
                        //       ?.members_details?.map((ele) => ele.admid)
                        //       ?.includes(item.value)
                        // )}
                        // value={member}
                        // onChange={(e) => {
                        //   if (e) {
                        //     setMember(e.map((item) => item));
                        //   } else {
                        //     setMember([]);
                        //   }
                        // }}

                        options={getEmpl}
                        onChange={(e) => setMemebr(e)}
                      />
                    </div>
                  </div>
                  <br />
                  <div style={{ marginBottom: "15px" }} className="col-sm-10">
                    <label>Module Name</label>
                    <Select
                      options={[
                        { label: "Attendance", value: "attendance" },
                        { label: "reimbursement", value: "reimbursement" },
                        { label: "Leave", value: "leave" },
                      ]}
                      value={moduleset}
                      onChange={(e) => setmoduleset(e)}
                    />
                  </div>

                  <div className="col-sm-4">
                    <button
                      style={{
                        background: "#0C41FF",
                        color: "#ffffff",
                        padding: "8px 20px",
                        border: "none",
                        borderRadius: "8px",
                      }}
                      onClick={() => handleAddMember()}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*** show members*/}
        <div
          id="show_mem"
          className="modal custom-modal fade"
          role="dialog"
        //data-bs-backdrop="static"
        //data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content"
              style={{ width: "450px", padding: "10px" }}
            >
              <div className="modal-header">
                <br />

                <h6 className="modal-title" style={{ marginBottom: "-10px" }}>
                  Members
                </h6>
                <button
                  type="button"
                  className="close-btn"
                  data-bs-dismiss="modal"
                >
                  X
                </button>
              </div>
              <div className="modal-body">
                {showmem.map((ele) => (
                  <p>{ele.name}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Edit group */}

        <div
          id="edit_group"
          className="modal custom-modal fade"
          role="dialog"
        //data-bs-backdrop="static"
        //data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content"
              style={{ width: "450px", padding: "10px" }}
            >
              <div className="modal-header">
                <br />

                <h6 className="modal-title" style={{ marginBottom: "-10px" }}>
                  {/* Change title based on mode */}
                  {editingGroup ? "Edit Group" : "Add Group"}
                </h6>
                <button
                  type="button"
                  ref={modalCloseRef}
                  className="close-btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setEditingGroup(null); // Reset editing state when closing
                    setGroupname(""); // Clear form
                    setModuleName(null);
                    setLevel1(null);
                    setLevel2(null);
                    setLevel3(null);
                  }}
                >
                  {/* <img src={closeIcon} /> */}X
                </button>
              </div>
              <hr />
              <div className="modal-body">
                <div style={{ marginTop: "-30px" }}>
                  <p style={{ fontWeight: "550" }}>Group Name :</p>
                  <input
                    type="text"
                    value={groupname}
                    style={{
                      border: "1px solid #3298DB",
                      borderRadius: "6px",
                      width: "100%",
                      padding: "7px",
                      background: "#f6f6f6",
                      marginTop: "-10px",
                    }}
                    onChange={(e) => setGroupname(e.target.value)}
                    disabled={!!editingGroup}
                  />
                </div>
                <hr />
                <div style={{ marginBottom: "15px" }}>
                  <label>Module Name</label>
                  <Select
                    options={[
                      { label: "Attendance", value: "attendance" },
                      { label: "reimbursement", value: "reimbursement" },
                      { label: "Leave", value: "leave" },
                    ]}
                    value={modulename}
                    // onChange={(e) => setModuleName(e)}
                    onChange={(e) => !editingGroup && setModuleName(e)} // Only allow changes when not editing
                    isDisabled={!!editingGroup}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "15px",
                    marginTop: "30px",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p style={{ fontSize: "16px", fontWeight: "500" }}>
                      Approval Level :{" "}
                    </p>
                  </div>
                  {/* <div style={{ marginTop: "-15px" }}>
                    <button
                      style={{
                        border: "1px solid #666666",
                        borderRadius: "50%",
                        fontSize: "15px",
                        color: "#FF0000",
                        background: "#ffffff",
                      }}
                    >
                      <FaMinus />
                    </button>
                  </div> */}
                  {/* <div>
                    <p style={{ fontSize: "16px" }}>6</p>
                  </div> */}
                  {/* <div style={{ marginTop: "-15px" }}>
                    <button
                      style={{
                        border: "1px solid #666666",
                        borderRadius: "50%",
                        fontSize: "15px",
                        color: "#0C41FF",
                        background: "#ffffff",
                      }}
                    >
                      <FaPlus />
                    </button>
                  </div> */}
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label>Level 1</label>
                  <Select
                    isClearable
                    style={{ border: "1px solid #3298DB" }}
                    onChange={(e) => setLevel1(e)}
                    // onChange={(selectedOption) => setLevel1(selectedOption)}
                    options={getEmpl}
                    value={level1}
                    isMulti
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label>Level 2</label>
                  <Select
                    isClearable
                    onChange={(e) => setLevel2(e)}
                    // onChange={(selectedOption) => setLevel2(selectedOption)}
                    options={getEmpl}
                    value={level2}
                    isMulti
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label>Level 3</label>
                  <Select
                    isClearable
                    onChange={(e) => setLevel3(e)}
                    // onChange={(selectedOption) => setLevel3(selectedOption)}
                    options={getEmpl}
                    value={level3}
                    isMulti
                  />
                </div>
                <div className="col-sm-2">
                  <button
                    style={{
                      background: "#0C41FF",
                      color: "#ffffff",
                      padding: "8px 20px",
                      border: "none",
                      borderRadius: "8px",
                    }}
                    onClick={() => editingGroup ? UpdateGroup() : PostGroup()}
                  >
                    {editingGroup ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Group Confirmation Modal */}
        <div className="modal fade" id="deleteConfirmModal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button type="button" className="close" data-bs-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                Are you sure you want to delete this approval group?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => deleteGroup(deleteGroupName)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Edit and Delete Members */}
        <div className="modal fade" id="editMembersModal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Manage Members: {editingGroup?.group_name}</h5>
                <button type="button" className="close" data-bs-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">

                {/* Add Members Section */}
                <div className="mb-4">
                  <h6>Add New Members</h6>
                  <Select
                    isMulti
                    options={getEmpl.filter(e =>
                      !currentGroupMembers.some(m => m.empid === e.value)
                    )}
                    onChange={(selected) => setNewMembersToAdd(selected)}
                    value={newMembersToAdd}
                    placeholder="Select members to add"
                  />
                  <button

                    className="btn btn-success btn-block mt-2"
                    style={{
                      padding: "5px 20px",
                      fontSize: "15px",
                      background: "#477BFF",
                      border: "none",
                      color: "white",
                    }}
                    onClick={handleAddMembers}
                    disabled={!newMembersToAdd || newMembersToAdd.length === 0}
                  >
                    Add Selected Members
                  </button>
                </div>

                {/* Remove Members Section */}
                <div>
                  <h6>Current Members</h6>
                  {currentGroupMembers.length > 0 ? (
                    <>
                      <div className="mb-2">
                        {currentGroupMembers.map(member => (
                          <div key={member.id} className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`member-${member.id}`}
                              checked={selectedMembersForRemoval.includes(member.id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedMembersForRemoval([...selectedMembersForRemoval, member.id]);
                                } else {
                                  setSelectedMembersForRemoval(
                                    selectedMembersForRemoval.filter(id => id !== member.id)
                                  );
                                }
                              }}
                            />
                            <label className="form-check-label" htmlFor={`member-${member.id}`}>
                              {member.name}
                            </label>
                          </div>
                        ))}
                      </div>
                      <button
                        className="btn btn-danger"
                        style={{
                          padding: "5px 20px",
                          fontSize: "15px",
                          // background: "#477BFF",
                          border: "none",
                          color: "white",
                        }}
                        onClick={handleRemoveMembers}
                        disabled={selectedMembersForRemoval.length === 0}
                      >
                        Remove Selected Members
                      </button>
                    </>
                  ) : (
                    <p>No members in this group</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
export default ApprovalPermission;
